import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router";
import { Link } from "zudoku/components";
import {
  getLocaleFromPath,
  LOCALE_LABELS,
  LOCALES,
  swapLocaleInPath,
  type Locale,
} from "../i18n";

export function LanguageSwitcher() {
  const location = useLocation();
  const [open, setOpen] = useState(false);
  const currentLocale = getLocaleFromPath(location.pathname);

  const localeLinks = useMemo(
    () =>
      LOCALES.map((locale) => ({
        locale,
        label: LOCALE_LABELS[locale],
        to: swapLocaleInPath(location.pathname, locale),
      })),
    [location.pathname],
  );

  useEffect(() => {
    document.documentElement.lang = currentLocale;
  }, [currentLocale]);

  return (
    <div className="relative ml-2">
      <button
        type="button"
        className="inline-flex items-center gap-1 rounded-md border border-border px-2 py-1 text-sm text-foreground hover:bg-accent"
        aria-haspopup="listbox"
        aria-expanded={open}
        onClick={() => setOpen((value) => !value)}
      >
        {LOCALE_LABELS[currentLocale]}
        <span aria-hidden="true">▾</span>
      </button>
      {open ? (
        <ul
          className="absolute right-0 z-50 mt-1 min-w-[9rem] rounded-md border border-border bg-background py-1 shadow-md"
          role="listbox"
          aria-label="Select language"
        >
          {localeLinks.map(({ locale, label, to }) => (
            <li key={locale}>
              <Link
                to={to}
                className={`block px-3 py-1.5 text-sm hover:bg-accent ${
                  locale === currentLocale ? "font-semibold text-primary" : ""
                }`}
                onClick={() => setOpen(false)}
              >
                {label}
              </Link>
            </li>
          ))}
        </ul>
      ) : null}
    </div>
  );
}
